import Api from 'lib/api';

import { SubmissionError } from 'redux-form';
import { toast } from 'react-toastify';

const api = Api.getInstance();

const ns = 'app/settings/';

export const LOAD_START = ns + 'LOAD_START';
export const LOAD_SUCCESS = ns + 'LOAD_SUCCESS';
export const LOAD_FAILURE = ns + 'LOAD_FAILURE';

export const SAVE_START = ns + 'SAVE_START';
export const SAVE_SUCCESS = ns + 'SAVE_SUCCESS';
export const SAVE_FAILURE = ns + 'SAVE_FAILURE';

export const UPDATE_VALUE = ns + 'UPDATE_VALUE';

export const ADD_TOUR_STEP = ns + 'ADD_TOUR_STEP';
export const REMOVE_TOUR_STEP = ns + 'REMOVE_TOUR_STEP';

export const ADD_CATEGORY = ns + 'ADD_CATEGORY';
export const REMOVE_CATEGORY = ns + 'REMOVE_CATEGORY';

export const SORT_TOUR_STEPS = ns + 'SORT_TOUR_STEPS';

export function load() {
  return async dispatch => {
    dispatch({
      type: LOAD_START
    });

    try {
      const response = await api.get('settings');
      const { success, settings } = response.data;

      if (success) {
        dispatch({
          type: LOAD_SUCCESS,
          payload: settings
        });
      } else {
        dispatch({
          type: LOAD_FAILURE,
          payload: response.data
        });
      }
    } catch (error) {
      let response = error;

      if (error.response && error.response.data) {
        response = error.response.data.data;
      }

      toast.error(response.message);

      dispatch({
        type: LOAD_FAILURE,
        payload: response
      });
    }
  };
}

export function save(saveData) {
  return async dispatch => {
    dispatch({
      type: SAVE_START
    });

    try {
      const response = await api.post('settings/save', saveData);
      const { settings, success } = response.data;

      if (success) {
        toast.success('Settings updated!');

        dispatch({
          type: SAVE_SUCCESS,
          payload: settings
        });

        return;
      } else {
        dispatch({
          type: SAVE_FAILURE,
          payload: response.data
        });
      }
    } catch (error) {
      let response = error;

      if (error.response && error.response.data) {
        response = error.response.data.data;
      }

      if (response) {
        toast.error(response.message);
      } else {
        toast.error('An error occured. Please try again.');
      }

      dispatch({
        type: SAVE_FAILURE,
        payload: response
      });

      if (response.errors) {
        let throwErrors = {};

        for (let field in response.errors) {
          throwErrors[field] = Object.values(response.errors[field]).join(', ');
        }

        throw new SubmissionError(throwErrors);
      }
    }
  };
}

export function updateValue(name, value) {
  return {
    type: UPDATE_VALUE,
    payload: {
      name,
      value
    }
  };
}

export function addTourStep(url = null) {
  return {
    type: ADD_TOUR_STEP,
    payload: url
  };
}

export function sortTourSteps(change) {
  return {
    type: SORT_TOUR_STEPS,
    payload: change
  };
}

export function removeTourStep(step) {
  return {
    type: REMOVE_TOUR_STEP,
    payload: step
  };
}

export function addCategory() {
  return {
    type: ADD_CATEGORY
  };
}

export function removeCategory(cat) {
  return {
    type: REMOVE_CATEGORY,
    payload: cat
  };
}



// WEBPACK FOOTER //
// ./src/components/app/settings/actions.js